import DeploymentJob from "./DeploymentJob";

export default DeploymentJob;
